export default __webpack_public_path__ + "static/media/info.25113e02.svg";